import React, { useCallback } from 'react';

import { useIsUpsellScreenEnabled } from '../../hooks';
import type { CustomizationScreenProps } from '../../navigation/AppNavigation.props';
import { Customization } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationScreen = (props: CustomizationScreenProps) => {
  const { navigation, route } = props;

  const { restaurantSlug, productSlug, reorderLineItemId } = route.params ?? {};

  const isUpsellScreenEnabled = useIsUpsellScreenEnabled();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleAddLineItemToCart = useCallback(() => {
    if (isUpsellScreenEnabled) {
      navigation.replace('UpsellScreen');

      return;
    }

    navigation.replace('Bag', { referrer: 'Menu' });
  }, [navigation, isUpsellScreenEnabled]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Customization
      restaurantSlug={restaurantSlug}
      productSlug={productSlug}
      onAddLineItemToCart={handleAddLineItemToCart}
      reorderLineItemId={reorderLineItemId}
      isEditProductMode={false}
    />
  );
};
